import React, { useRef } from "react";
import { HiPrinter, HiPlus } from "react-icons/hi";
import { useReactToPrint } from "react-to-print";

const ProductionSetupDetailContent = ({ setupList, details, onNewSetUp }) => {
  const componentRef = useRef();

  console.log('details ', details);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `${details?.production_item_name || "Production"} Setup`,
    pageStyle: `
      @page { size: A4; margin: 20mm; }
      @media print {
        .no-print { display: none !important; }
        body { font-family: 'Inter', sans-serif; }
      }
    `,
  });

  return (
    <div ref={componentRef} className="min-h-full bg-white">
      {/* Header Section */}
      <div className="border-b bg-white sticky top-0 z-10 no-print">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-8 py-5 flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">
              {details?.production_item_name || "Production Setup"}
            </h1>
            <div className="mt-1 flex items-center gap-6 text-sm text-gray-600">
              <div>
                <span className="font-medium">Item Code:</span>{" "}
                {details?.production_item_id || "—"}
              </div>
              <div>
                <span className="font-medium">SKU:</span>{" "}
                {details?.production_item_sku || "—"}
              </div>
            </div>
          </div>

          <div className="flex items-center gap-3">
            <button
              onClick={handlePrint}
              title="Print / Export"
              className="p-2.5 rounded-lg hover:bg-gray-100 text-gray-700 transition-colors"
            >
              <HiPrinter size={22} />
            </button>

        
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-[1400px] mx-auto px-6 lg:px-8 py-8">
        {setupList?.length === 0 ? (
          <div className="bg-gray-50 border border-gray-200 rounded-xl p-10 text-center">
            <h3 className="text-lg font-semibold text-gray-700 mb-2">
              No required items yet
            </h3>
            <p className="text-gray-500 mb-6">
              This production setup doesn't have any required materials defined.
            </p>
            <button
              onClick={onNewSetUp}
              className="inline-flex items-center gap-2 px-6 py-3 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg font-medium"
            >
              <HiPlus size={18} />
              Create New Setup
            </button>
          </div>
        ) : (
          <div className="overflow-x-auto rounded-xl border border-gray-200 shadow-sm">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th
                    scope="col"
                    className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
                  >
                    ID
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
                  >
                    Item Name
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
                  >
                    SKU
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
                  >
                    Category
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
                  >
                    Required Qty
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-100">
                {setupList.map((item, idx) => (
                  <tr
                    key={item.item_id || idx}
                    className="hover:bg-indigo-50/30 transition-colors"
                  >
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700 font-medium">
                      {item?.item_id || "—"}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                      {item?.item_name || item?.item_Name || "—"}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                      {item?.item_sku || "—"}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                      {item?.item_category_name || "—"}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-semibold text-indigo-700">
                      {item?.required_quantity || item?.No_of_Required_Item || "0"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* Print-only footer (optional branding) */}
        <div className="hidden print:block mt-10 text-center text-sm text-gray-500">
          Generated on {new Date().toLocaleDateString()} • Production Setup Report
        </div>
      </div>
    </div>
  );
};

export default ProductionSetupDetailContent;